import { render } from "./FileStructure.vue?vue&type=template&id=24d7eb6c&scoped=true"
import script from "./FileStructure.vue?vue&type=script&lang=js"
export * from "./FileStructure.vue?vue&type=script&lang=js"

import "./FileStructure.vue?vue&type=style&index=0&id=24d7eb6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d7eb6c"]])

export default __exports__